import { useCallback } from 'react';
import { ReactComponent as Check } from '../../assets/quiz/check-circle.svg';

import Show from '../../utility/Show';
import FormError from '../../utility/FormError';

const QuizOptions = ({ errorMessage, currentQuestion, onOptionClick, answerList }) => {

  const optionClick = useCallback((property, option) => {
    onOptionClick(property, {
      question: currentQuestion.question,
      answer: option,
    });
  }, [currentQuestion.question, onOptionClick]);

  const isChecked = useCallback((option) => {
    return answerList.find((item) => item.answer === option);
  }, [answerList]);

  return (
    <form className="options-container">
      <h2 className="question-title">{currentQuestion.question}</h2>
      {currentQuestion.options.map((option, index) => (
        <div
          key={`option-${index}`}
          className={`option-wrapper ${isChecked(option) ? 'selected-option' : ''}`}
          onClick={() => optionClick(currentQuestion.id, option)}
        >
          {option.label}
          <Show.When isTrue={isChecked(option)}>
            <Check />
          </Show.When>
        </div>
      ))}
      <Show.When isTrue={errorMessage}>
        <FormError error={errorMessage} textColor="#ed5951" />
      </Show.When>
    </form>
  );
};

export default QuizOptions;
